export default {"src":"/_next/static/media/via.27a0bca2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};